/**
 * Navigation extensions for the new Backstage frontend system.
 * Provides custom sidebar with logo, environment badge, and navigation items.
 *
 * @packageDocumentation
 */

import { type ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarContent } from '../components/nav/Sidebar';

/**
 * Custom sidebar extension using NavContentBlueprint.
 * Renders the IntelliPact Admin Portal sidebar with:
 * - Custom logo (responsive full/icon variants)
 * - Environment badge (DEV/TEST/STG/PROD)
 * - Search field
 * - Navigation items from all plugins
 */
const customSidebar = NavContentBlueprint.make({
  params: {
    component: SidebarContent,
  },
});

/**
 * All navigation extensions exported as an array for easy registration.
 */
export const navExtensions: ExtensionDefinition[] = [customSidebar];
